module.exports = __webpack_public_path__ + "static/media/batteryGreenFilled.f1e7118b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DevicesList/batteryGreenFilled.svg
// module id = 827
// module chunks = 0